import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "@/api";
import { ADMIN } from "@/constants/testIds";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await adminLogin(username.trim(), password);
      navigate("/admin/dashboard");
    } catch (e) {
      setErr(
        typeof e?.response?.data?.detail === "string"
          ? e.response.data.detail
          : "Login failed."
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="term-container fade-in" data-testid={ADMIN.loginRoot}>
      <div className="kbd-label">// privileged access</div>
      <h1 style={{ margin: "0.2rem 0 1rem", color: "var(--ax-accent)" }}>
        ADMIN
      </h1>
      <p className="faint" style={{ fontSize: 12 }}>
        $ sudo axiom --moderate
      </p>
      <form onSubmit={submit} style={{ maxWidth: 360, marginTop: "1rem" }}>
        <label className="kbd-label" htmlFor="u">
          USERNAME
        </label>
        <input
          id="u"
          data-testid={ADMIN.usernameInput}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoComplete="username"
          required
        />
        <div style={{ height: 12 }} />
        <label className="kbd-label" htmlFor="p">
          PASSWORD
        </label>
        <input
          id="p"
          data-testid={ADMIN.passwordInput}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />
        <div style={{ marginTop: "1rem" }}>
          <button
            type="submit"
            data-testid={ADMIN.loginSubmit}
            disabled={busy || !password}
          >
            {busy ? "AUTHENTICATING…" : "AUTHENTICATE"}
          </button>
        </div>
        {err && (
          <div style={{ color: "var(--ax-danger)", marginTop: 12, fontSize: 12 }}>
            {err}
          </div>
        )}
      </form>
    </div>
  );
};

export default AdminLogin;
